import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsFinanceEfficiency: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_FINANCE_EFFICIENCY].GET_REPORTS_FINANCE_EFFICIENCY,
	},
}
